<form [formGroup]="testatorForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{ formTitle }}</h1>
    <p class="lead rocal">{{ formSubtitle }}</p>


    <!-- Panel 1: Contact Info -->
    <ng-template #contactInfo let-i="index">
      <div *ngIf="getTestatorFormGroup(i)">
        <div class="line-section"></div>
        <div class="row-alt">
          <div class="row-mini">
            <app-input [formGroup]="getTestatorFormGroup(i)" controlName="Title" label={{titleLabel}} hint={{titleHint}}
              required="false" inputType="auto-complete" [loadingOptions]="loadingTitles" [ArrayItems]="TitleOptions"
              [validationMessages]="validationMessages" [formErrors]="formErrors">
            </app-input>

            <app-input [formGroup]="getTestatorFormGroup(i)" controlName="FirstName" label={{fNameLabel}}
              hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>

          <div class="row-mini">
            <app-input [formGroup]="getTestatorFormGroup(i)" controlName="MiddleName" label={{mNameLabel}}
              hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getTestatorFormGroup(i)" controlName="LastName" label={{surnameLabel}}
              hint={{surnameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>

        </div>

        <div class="row">
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="Phone" label={{phoneLabel}}
            inputType="phone" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

          <app-input [formGroup]="getTestatorFormGroup(i)" controlName="SecondaryPhone" class="grid-item"
            *ngIf="region === 1" label="Secondary Phone Number" inputType="phone" required="false"
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <!-- Kenya only email input -->
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" *ngIf="region === 0" controlName="Email"
            label={{emailLabel}} hint={{emailLabel}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div class="row" [ngClass]="{half: region === 0}">
          <!-- Diaspora email input -->
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="Email" *ngIf="region === 1"
            label={{emailLabel}} hint={{emailLabel}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="IDNo" label={{idLabel}}
            hint={{idHint}} [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 2: Details -->
    <ng-template #details let-i="index">
      <div *ngIf="getTestatorFormGroup(i)">
        <div class="line-section"></div>
        <div class="row">
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="KraPin" label={{kraPinLabel}}
            hint={{kraPinHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="Address"
            label={{addressLabel}} hint={{addressHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div class="row half">
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="PostalAddress"
            label={{postalLabel}} hint={{postalHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 3: Upload Documents -->
    <ng-template #uploadDocs let-i="index">
      <div *ngIf="getTestatorFormGroup(i)">
        <div class="line-section"></div>
        <div class="row">
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="IDNoImage"
            label={{idFileLabel}} [fileFunction]="updateIDObject.bind(this, i)"
            [existingFileName]="testators[i]?.IDNoImage?.name != '' ? testators[i]?.IDNoImage?.name : '' "
            inputType="file" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getTestatorFormGroup(i)" class="grid-item" controlName="KraPinImage"
            label={{kraFileLabel}} [fileFunction]="updateKraObject.bind(this, i)"
            [existingFileName]="testators[i]?.KraPinImage?.name != '' ? testators[i]?.KraPinImage?.name : '' "
            inputType="file" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>


    <div formArrayName="testators">
      <div *ngFor="let settlor of getTestators().controls; let i=index" [formGroupName]="i" style="position: relative;">

        <div style="height: 40px;" *ngIf="i > 1"></div>
        <p style="font-weight: 600; font-size: 1.3em;" class="blue margin" *ngIf="getTestators().length > 1">
          {{'Testator ' + (i+1)}}
        </p>

        <!-- Accordion -->
        <app-section [panels]="testatorPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>

        <div class="action-buttons">
          <button *ngIf="i > 0" mat-stroked-button type="button" class="remove" (click)="removeTestator(i)">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{ getTestators().controls.length-1 === i ? removeButtonText : removeTestatorText
                  }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getTestators() && !confirmFormMatchesRecord(i)"
            [disabled]="loading || loadingRemove" (click)="updateRecord(i)">
            <span class="button-text">
              {{ 'Update testator ' +(i+1) }}
            </span>
          </button>
        </div>
      </div>

      <!-- BUTTTON Add Testator -->
      <div class="blueStroke row" [ngClass]="{'min-55' : getTestators().length > 1}">
        <button mat-stroked-button *ngIf="testators[testators.length-1] && testators[testators.length-1].done === true"
          [disabled]="loading || loadingRemove" class="general-stroked-button" type="button" (click)="addNewTestator()">
          <span class="button-text">
            {{ addTestatorText }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;" [service]="estateControlService" [text]="
            loading ? loadingText :
            testators[testators.length-1] && testators[testators.length-1].done == true ? 'Next' :
            testators[testators.length-1] && testators[testators.length-1].verified == false ? 'Verify via OTP' :
            !consentProvided && testators.length <= 1 ? 'Terms and Data Privacy' : 'Save Details'
        " [formValid]="
            (testators[testators.length-1] && testators[testators.length-1].done) ? true :
            testatorForm.valid ? true : false
        " [showContinue]="'false'" [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>